import React from 'react';
import { createHashRouter, Navigate } from 'react-router-dom';

import ApiRoot from '@/core/screens/api-root';
import PaymentRedirect from '@/core/screens/payment-redirect';
import Root from '@/core/screens/root';
import Error from '@/journey-based-listing/screens/error';

import { buildJourneyRoutes } from './journeys';
import { locationLoader } from './loaders/locationLoader';

/**
 * Plain anchor links on the host page (e.g. <a href="#book-now">) produce hashes
 * without a leading slash. The hash router parses those to a pathname like
 * "book-now", which matches no route — not even the '*' catch-all — and 404s.
 * Rewriting to "#/book-now" lets the router match it normally or fall through
 * to the catch-all redirect.
 */
export const normalizeHash = () => {
    const { hash } = window.location;
    if (hash && !hash.startsWith('#/')) {
        // replace() avoids an extra history entry so the back button still works.
        window.location.replace(`#/${hash.slice(1)}`);
    }
};

export const createAppRouter = () => {
    normalizeHash();
    // Registered before createHashRouter so this runs ahead of the router's own
    // popstate listener — the hash is already normalized when the router matches.
    window.addEventListener('popstate', normalizeHash);
    return createHashRouter(
        [
            {
                path: '/',
                element: <Root />,
                loader: locationLoader,
                errorElement: <Error />,
                children: buildJourneyRoutes(),
            },
            {
                path: '/api',
                element: <ApiRoot />,
                loader: locationLoader,
                children: [
                    {
                        path: 'payment-redirect/:token/:type',
                        element: <PaymentRedirect />,
                        loader: locationLoader,
                        errorElement: <Error />,
                    },
                ],
            },
            {
                path: '*',
                element: <Navigate to="/" replace />,
            },
        ],
        { basename: '/' },
    );
};
